import { ApiConfig } from '../../api/factoryApi';
import { getUserData } from './getUserData';

export const apiConfig: ApiConfig = {
  //@ts-ignore
  baseUrl: window?.stepperData?.config?.urlApi || window.location.origin,
  // baseUrl: 'https://creditsfast.com',
  entry: {
    getUser: {
      url: '/stepper/start/',
      mockData: {
        status: 200,
        response: getUserData
      }
    },
    create: {
      url: '/stepper/create/',
      mockData: {
        status: 200,
        response: {status: true, test: true}
      }
    },
    update: {
      url: '/stepper/update/',
      mockData: {
        status: 200,
        response: {status: true, test: true}
      }
    },
    validation: {
      url: '/stepper/validate/',
      mockData: {
        status: 200,
        response: {status: 'success', error: {email: 'Document Type es muy largo'}}
      }
    },
    finish: {
      url: '/stepper/end/',
    }
  }
}